/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"

import Nav from "@components/nav"
import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import AppContext from "@src/context/appContext"
import { wxConfig, wxShare } from "@src/utils/wechat"

const Layout = ({ children, location }) => {
  useEffect(() => {
    wxConfig()
    wxShare()
  }, [])
  return (
    <AppContext.Provider value={{}}>
      <Seo />
      <Nav location={location} />
      <div className={styles.container}>
        <main>{children}</main>
      </div>
      <footer className={styles.footer}>
        <div className={styles.footerLeft}></div>
        <div className={styles.footerRight}>
          GCORES 2024 ALL RIGHTS RESERVED
        </div>
      </footer>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
